import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      gap: '10px',
      padding: '6px 16px 6px 8px',
      // minWidth: '160px',
      width: 'fit-content',
      height: '42px',
      color: 'black',
      fontWeight: theme.fontWeights.medium,
      border: `1px solid ${theme.colors.shark}`,
      borderRadius: '12px',
      alignItems: 'center',
      justifyContent: 'flex-start',
      fontSize: '16px',
      lineHeight: '16px',
    },
    icon: {
      width: '30px',
      height: '30px',
    },
  }),
  { name: 'DineAnytime' },
);

export default useStyles;
